const styles = (theme) => ({
  root: {
    width: '100%',
    overflow: 'auto',
    textAlign: 'center',
    maxHeight: 500
  }
})

export {
  styles
}
